import React from 'react';

const GreenTickSvg = ({ className }: { className?: string }) => (
  <svg className={className} width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 12c0 6.628 5.372 12 12 12s12-5.372 12-12S18.628 0 12 0 0 5.372 0 12Z" fill="#1E9771" />
    <path d="M17.994 7.838a.986.986 0 0 1 0 1.395l-6.934 6.93a.986.986 0 0 1-1.383.012l-3.659-3.538a.986.986 0 1 1 1.371-1.418l2.962 2.864L16.6 7.837a.986.986 0 0 1 1.395 0Z" fill="#fff" />
  </svg>
);

export default GreenTickSvg;
